import React, { useEffect } from 'react';
import Slider from '../Componenets/Slider'

const Products = () => {
    useEffect(() => {
        window.scrollTo(0, 0); // Scrolls to the top of the page
    }, []);
    return (
        <div>
            <div>
                <section class="boldSection bottomSemiSpaced btPageHeadline gutter  topSemiSpaced btTextLeft wBackground cover btParallax btDarkSkin btBackgroundOverlay btSolidDarkBackground " style={{
                    backgroundColor: "#142340",marginLeft:"-20px", backgroundImage: `url(& quot; https://industrial.bold-themes.com/blue-laboratory/wp-content/uploads/sites/11/2016/09/hero_inner_page.jpg&quot;)`, backgroundPosition: 50 % 40.5384, dataParallax: "0.8", dataParallaxOffset: "0"
                }}><div class="port">
                        <header class="header btClear large">
                            <div class="btSuperTitle"><span>
                                <div class="btBreadCrumbs">
                                    <nav><ul><li>
                                        <a href="https://industrial.bold-themes.com/blue-laboratory/">Home</a></li>
                                        <li><a href="https://industrial.bold-themes.com/blue-laboratory/about-us/">Products</a></li></ul></nav>
                                </div></span>
                            </div><div class="dash"><h2><span class="headline"> Products</span></h2></div><div class="btSubTitle">"Welcome to our product review page, your destination for honest and insightful reviews of our latest offerings. Get the inside scoop on our products and make informed decisions before making a purchase.".</div>
                            </header></div></section>



                <section id="bt_section66274e99a6b1a" className="boldSection topSemiSpaced gutter boxed inherit">
                    <div className="port">
                        <div className="boldCell">
                            <div className="boldCellInner">
                                <div className="boldRow">
                                    <div className="boldRowInner">
                                        {/* First Column */}
                                        <div className="rowItem col-md-4 col-ms-12 btTextLeft animate animate-fadein inherit animated" data-width="4">
                                            <div className="rowItemContent">
                                                <div className="bpgPhoto btHasTitles out-left">
                                                    <a href="#" target="_self" title="Automotive parts and systems"></a>
                                                    <div className="boldPhotoBox">
                                                        <div className="bpbItem">
                                                            <div className="btImage">
                                                                <img decoding="async" src="./Images/x1.jpg" alt="" title="Automotive parts and systems" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="captionPane btDarkSkin btTextCenter">
                                                        <div className="captionTable">
                                                            <div className="captionCell">
                                                                <div className="captionTxt">
                                                                    <header className="header btClear extrasmall">
                                                                        <div className="dash">
                                                                            <h4><span className="headline">Perforated Sheets</span></h4>
                                                                        </div>
                                                                    </header>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="btShowTitle" style={{backgroundColor:"black"}}>
                                                        <div className="btShowTitleCaptionTxt">
                                                            <header className="header btClear small">
                                                                <div className="dash">
                                                                    <h4><span className="headline">Perforated Sheets</span></h4>
                                                                </div>
                                                            </header>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder"></div>
                                            </div>
                                        </div>
                                        {/* Second Column */}
                                        <div className="rowItem col-md-4 col-ms-12 btTextLeft animate animate-fadein inherit animated" data-width="4">
                                            <div className="rowItemContent">
                                                <div className="bpgPhoto btHasTitles out-left">
                                                    <a href="#" target="_self" title="Chemical research"></a>
                                                    <div className="boldPhotoBox">
                                                        <div className="bpbItem">
                                                            <div className="btImage">
                                                                <img  decoding="async" src="./Images/x2.jpg" alt="" title="Chemical research" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="captionPane btDarkSkin btTextCenter">
                                                        <div className="captionTable">
                                                            <div className="captionCell">
                                                                <div className="captionTxt">
                                                                    <header className="header btClear extrasmall">
                                                                        <div className="dash">
                                                                            <h4><span className="headline">Fuel Strainers</span></h4>
                                                                        </div>
                                                                    </header>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="btShowTitle" style={{backgroundColor:"black"}}>
                                                        <div className="btShowTitleCaptionTxt">
                                                            <header className="header btClear small">
                                                                <div className="dash">
                                                                    <h4><span className="headline">Press Componenets</span></h4>
                                                                </div>
                                                            </header>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder"></div>
                                            </div>
                                        </div>
                                        {/* Third Column */}
                                        <div className="rowItem col-md-4 col-ms-12 btTextLeft animate animate-fadein inherit animated" data-width="4">
                                            <div className="rowItemContent">
                                                <div className="bpgPhoto btHasTitles out-left">
                                                    <a href="#" target="_self" title="Power & Energy"></a>
                                                    <div className="boldPhotoBox">
                                                        <div className="bpbItem">
                                                            <div className="btImage">
                                                                <img style={{height:"200px",width:"350px"}} decoding="async" src="./Images/x3.jpg" alt="" title="Power & Energy" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="captionPane btDarkSkin btTextCenter">
                                                        <div className="captionTable">
                                                            <div className="captionCell">
                                                                <div className="captionTxt">
                                                                    <header className="header btClear extrasmall">
                                                                        <div className="dash">
                                                                            <h4><span className="headline">Pressed Componenets</span></h4>
                                                                        </div>
                                                                    </header>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="btShowTitle" style={{backgroundColor:"black"}}>
                                                        <div className="btShowTitleCaptionTxt">
                                                            <header className="header btClear small">
                                                                <div className="dash">
                                                                    <h4><span className="headline">Fuel Strainers</span></h4>
                                                                </div>
                                                            </header>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="btClear btSeparator topSmallSpaced bottomSmallSpaced noBorder"></div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>


                <Slider />



            </div>
        </div>
    )
}

export default Products
